'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TopLeftMenu = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _dispatcher = require('../../../dispatcher');

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _languageHandler = require('../../../languageHandler');

var _LogoutDialog = require('../dialogs/LogoutDialog');

var _LogoutDialog2 = _interopRequireDefault(_LogoutDialog);

var _Modal = require('../../../Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _SdkConfig = require('../../../SdkConfig');

var _SdkConfig2 = _interopRequireDefault(_SdkConfig);

var _HostingLink = require('../../../utils/HostingLink');

var _MatrixClientPeg = require('../../../MatrixClientPeg');

var _MatrixClientPeg2 = _interopRequireDefault(_MatrixClientPeg);

var _index = require('../../../index');

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
Copyright 2018, 2019 New Vector Ltd
Copyright 2019 The Matrix.org Foundation C.I.C.

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

var TopLeftMenu = exports.TopLeftMenu = function (_React$Component) {
    (0, _inherits3.default)(TopLeftMenu, _React$Component);

    function TopLeftMenu() {
        (0, _classCallCheck3.default)(this, TopLeftMenu);

        var _this = (0, _possibleConstructorReturn3.default)(this, (TopLeftMenu.__proto__ || (0, _getPrototypeOf2.default)(TopLeftMenu)).call(this));

        _this.viewHomePage = _this.viewHomePage.bind(_this);
        _this.openSettings = _this.openSettings.bind(_this);
        _this.signIn = _this.signIn.bind(_this);
        _this.signOut = _this.signOut.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(TopLeftMenu, [{
        key: 'hasHomePage',
        value: function hasHomePage() {
            var config = _SdkConfig2.default.get();
            var pagesConfig = config.embeddedPages;
            if (pagesConfig && pagesConfig.homeUrl) {
                return true;
            }
            // This is a deprecated config option for the home page
            // (despite the name, given we also now have a welcome
            // page, which is not the same).
            return !!config.welcomePageUrl;
        }
    }, {
        key: 'render',
        value: function render() {
            var AccessibleButton = _index2.default.getComponent('elements.AccessibleButton');

            var isGuest = _MatrixClientPeg2.default.get().isGuest();

            var hostingSignupLink = (0, _HostingLink.getHostingLink)('user-context-menu');
            var hostingSignup = null;
            if (hostingSignupLink) {
                hostingSignup = _react2.default.createElement(
                    'div',
                    { className: 'mx_TopLeftMenu_upgradeLink' },
                    (0, _languageHandler._t)("<a>Upgrade</a> to your own domain", {}, {
                        a: function a(sub) {
                            return _react2.default.createElement(
                                'a',
                                { href: hostingSignupLink, target: '_blank', rel: 'noopener', tabIndex: '0' },
                                sub
                            );
                        }
                    }),
                    _react2.default.createElement(
                        'a',
                        { href: hostingSignupLink, target: '_blank', rel: 'noopener', 'aria-hidden': true },
                        _react2.default.createElement('img', { src: require("../../../../res/img/external-link.svg"), width: '11', height: '10', alt: '' })
                    )
                );
            }

            var homePageItem = null;
            if (this.hasHomePage()) {
                homePageItem = _react2.default.createElement(
                    AccessibleButton,
                    { element: 'li', className: 'mx_TopLeftMenu_icon_home', onClick: this.viewHomePage },
                    (0, _languageHandler._t)("Home")
                );
            }

            var signInOutItem = void 0;
            if (isGuest) {
                signInOutItem = _react2.default.createElement(
                    AccessibleButton,
                    { element: 'li', className: 'mx_TopLeftMenu_icon_signin', onClick: this.signIn },
                    (0, _languageHandler._t)("Sign in")
                );
            } else {
                signInOutItem = _react2.default.createElement(
                    AccessibleButton,
                    { element: 'li', className: 'mx_TopLeftMenu_icon_signout', onClick: this.signOut },
                    (0, _languageHandler._t)("Sign out")
                );
            }

            var settingsItem = _react2.default.createElement(
                AccessibleButton,
                { element: 'li', className: 'mx_TopLeftMenu_icon_settings', onClick: this.openSettings },
                (0, _languageHandler._t)("Settings")
            );

            return _react2.default.createElement(
                'div',
                { className: 'mx_TopLeftMenu', ref: this.props.containerRef },
                _react2.default.createElement(
                    'div',
                    { className: 'mx_TopLeftMenu_section_noIcon', 'aria-readonly': true },
                    _react2.default.createElement(
                        'div',
                        null,
                        this.props.displayName
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'mx_TopLeftMenu_greyedText', 'aria-hidden': true },
                        this.props.userId
                    ),
                    hostingSignup
                ),
                _react2.default.createElement(
                    'ul',
                    { className: 'mx_TopLeftMenu_section_withIcon' },
                    homePageItem,
                    settingsItem,
                    signInOutItem
                )
            );
        }
    }, {
        key: 'viewHomePage',
        value: function viewHomePage() {
            _dispatcher2.default.dispatch({ action: 'view_home_page' });
            this.closeMenu();
        }
    }, {
        key: 'openSettings',
        value: function openSettings() {
            _dispatcher2.default.dispatch({ action: 'view_user_settings' });
            this.closeMenu();
        }
    }, {
        key: 'signIn',
        value: function signIn() {
            _dispatcher2.default.dispatch({ action: 'start_login' });
            this.closeMenu();
        }
    }, {
        key: 'signOut',
        value: function signOut() {
            _Modal2.default.createTrackedDialog('Logout E2E Export', '', _LogoutDialog2.default);
            this.closeMenu();
        }
    }, {
        key: 'closeMenu',
        value: function closeMenu() {
            if (this.props.onFinished) this.props.onFinished();
        }
    }]);
    return TopLeftMenu;
}(_react2.default.Component);

TopLeftMenu.propTypes = {
    displayName: _propTypes2.default.string.isRequired,
    userId: _propTypes2.default.string.isRequired,
    onFinished: _propTypes2.default.func,

    // Optional function to collect a reference to the container
    // of this component directly.
    containerRef: _propTypes2.default.func
};
//# sourceMappingURL=TopLeftMenu.js.map